import {
  createFileRoute,
  Outlet,
  useParams,
  useRouterState,
} from '@tanstack/react-router'

import { NnppImportVerificationProvider } from '@/src/pages/nnpp/imports/NnppImportVerificationProvider'

function NnppImportDocumentLayout() {
  const { importId = '', documentId = '' } = useParams({ strict: false })
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  })
  const isVerification = pathname.endsWith('/import-verification')
  const isSummary = pathname.endsWith('/summary')

  return (
    <NnppImportVerificationProvider
      key={JSON.stringify([importId, documentId])}
      importId={importId}
      documentId={documentId}
      enabled={isVerification || isSummary}
      loadSourcePdf={isVerification}>
      <Outlet />
    </NnppImportVerificationProvider>
  )
}

export const Route = createFileRoute(
  '/nnpp/imports/$importId/documents/$documentId'
)({
  component: NnppImportDocumentLayout,
  staticData: { layout: { enableScrolling: true } },
})
